import { EisFlagStatus } from '../_types/eis';

export function getStatusBadgeColor(status: EisFlagStatus): 'success' | 'warning' | 'default' {
  if (status === 'Active') return 'success';
  if (status === 'Cleared') return 'warning';
  return 'default';
}
